/**
 * This fetches promo grid / carousel items based on a persona for static-like
 * pages on the WWW site (Doctors, Services, Locations, etc.) and renders them
 * using Handlebars templates. Not really that much special going on!
 */

/**
import { renderPromoCarousel } from '../common/_fetch-promo-carousel.js';
import { renderPromoGrid } from '../common/_fetch-promo-grid.js';
**/

function renderPromoCarousel() {
  let Flickity   = require('flickity');
  let promoCarousel = document.getElementById('default-carousel');
  let loadingCell = document.getElementById('loading-cell');
  if ( loadingCell ) {
    loadingCell.remove();
  }
  if ( promoCarousel ) {
    promoCarousel.classList.remove('d-none');
    [ 'play', 'stop', 'pause', 'unpause' ].forEach( function( action ) {
      var methodName = action + 'Player';
      Flickity.prototype[ methodName ] = function() {
        this.player[ action ]();
        this.dispatchEvent( methodName );
      };
    });
    
    var flkty = new Flickity( promoCarousel, {
      autoPlay: 6000,
      cellAlign: 'center',
      contain: false,
      draggable: '>1',
      dragThreshold: 8,
      freeScroll: false,
      initialIndex: 0,
      lazyLoad: true,
      imagesLoaded: true,
      pageDots: false,
      selectedAttraction: 0.03,
      friction: 0.5,
      wrapAround: false,
      imagesLoaded: true,
      on: {
        ready: () => {
          document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
            el.setAttribute('tabindex', '-1');
          })
        },
        select: () => { 
          document.querySelectorAll('.carousel-cell.is-selected a, .carousel-cell.is-selected button').forEach((el) => {
            el.removeAttribute('tabindex');
          })

          document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
            el.setAttribute('tabindex', '-1');
          })
        },
        pausePlayer: () => {
          promoCarousel.setAttribute('aria-live', 'polite');
        },
        stopPlayer: () => {
          promoCarousel.setAttribute('aria-live', 'polite');
        },
        playPlayer: () => {
          promoCarousel.setAttribute('aria-live', 'off');
        },
        unpausePlayer: () => {
          promoCarousel.setAttribute('aria-live', 'off');
        }
      }
    });
  }


}

/**
 * Fetches default promos for a given persona and renders them on page
 */
export default function renderDefaultPromos() {
  /*
   * 4/4/2022:
   * Trying to disable this for all pages except homepage. There are almost
   * never persona-based promos for individual pages and this contributes
   * to a major slowdown on the site.
   *
   */
  renderPromoCarousel();
  // renderPromoGrid();
}

renderDefaultPromos();
